import React, { useEffect, useState } from 'react';
import SectionTitle from '../Common/SectionTitle';

const TSS = () => {
  // Add state to track the active year tab
  const [activeYear, setActiveYear] = useState(2);

  // Set correct page title and scroll to top when component mounts
  useEffect(() => {
    document.title = "Tally Software Services (TSS) | Digisoft";
    window.scrollTo(0, 0);
    
    // Add Font Awesome script for icons
    const fontAwesomeScript = document.createElement('script');
    fontAwesomeScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/js/all.min.js'; 
    fontAwesomeScript.crossOrigin = 'anonymous';
    document.head.appendChild(fontAwesomeScript);
    
    // Apply consistent font styling
    const fontStyle = document.createElement('style');
    fontStyle.textContent = `
      * {
        font-family: "Roboto Regular", "Roboto", sans-serif !important;
      }
      
      /* Keep special styling for price numbers */
      .price-amount {
        font-family: "Roboto Regular", "Roboto", sans-serif !important;
        font-weight: 700 !important;
      }

      /* TSS specific styles */
      .feature-list {
        list-style: none;
        padding-left: 0;
      }
      
      .feature-list li {
        padding: 8px 0;
        position: relative;
        padding-left: 28px;
      }
      
      .feature-list li:before {
        content: none;
      }
      
      .feature-list li img {
        position: absolute;
        left: 0;
        top: 10px;
        width: 16px;
        height: 16px;
      }
      
      .feature-list li.emi-available {
        color: #0d6efd;
        font-weight: 500;
      }

      .bg-theme {
        background-color: #f5f6fb;
      }

      .text-theme {
        color: #0d6efd;
      }

      .custom-shadow-bottom {
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
        transition: all 0.3s ease;
      }

      .custom-shadow-bottom:hover {
        transform: translateY(-5px);
      }

      .card {
        border-radius: 12px;
        overflow: hidden;
      }

      .bg-light-cream {
        background-color: #f9f9f9;
      }

      .arrow-animation .arrow {
        transition: transform 0.3s ease;
      }

      .arrow-animation:hover .arrow {
        transform: translate(3px, -3px);
      }

      .off-tag {
        top: 12px;
        right: -5px;
        z-index: 2;
      }

      .card-height {
        min-height: 550px;
      }

      .nav-pills .nav-link.active {
        background-color: #0d6efd;
        color: white;
      }

      .durationTabTSS {
        cursor: pointer;
        padding: 8px 16px;
        border-radius: 5px;
        transition: all 0.3s ease;
      }

      .durationTabTSS:hover {
        background-color: #e9ecef;
      }

      .durationTabTSS.active {
        background-color: #0d6efd;
        color: white;
      }
    `;
    document.head.appendChild(fontStyle);

    return () => {
      document.title = "Digisoft Services";
      document.head.removeChild(fontStyle);
      document.head.removeChild(fontAwesomeScript);
    };
  }, []);

  // Updated Function to handle year change
  const handleYearChange = (years) => {
    setActiveYear(years);
    console.log(`Selected ${years} year(s)`);
  };

  // Hero section background style
  const heroBackgroundStyle = {
    backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/hero-bg-2.jpg)`,
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    opacity: 0.1,
    margin: 0,
    padding: 0
  };

  const keyBenefits = [
    {
      title: 'Connected GST experience',
      description: 'Simplifies GST filing, e-invoicing, reconciliation, and e-way bill generation.'
    },
    {
      title: 'Free product upgrades and updates',
      description: 'Regular updates ensure compatibility with the latest technological and statutory changes.'
    },
    {
      title: 'Online access to reports and data',
      description: 'Secured access to business reports on mobile or any device.'
    },
    {
      title: 'Online data synchronization',
      description: 'Sync data across branches, factories, or warehouses.'
    }
  ];

  const testimonials = [
    {
      company: 'Bajaj Electricals',
      quote: 'TallyPrime simplified our distribution network, making billing, data integration, and supply chain management effortless.'
    },
    {
      company: 'Mohan & Chandrashekhar CA Firm',
      quote: 'TallyPrime has transformed our accounting and client services by automating processes.'
    }
  ];

  const faqs = [
    {
      question: 'What is the validity of TSS?',
      answer: 'TSS subscription is available for 1 or 2 years. The validity starts from the date of activation and remains active until the end of the chosen period.'
    },
    {
      question: 'Can I renew the subscription before the end of the validity period?',
      answer: 'Yes, you can renew your TSS subscription at any time. Renewing before expiry ensures continuous access to all TSS features without interruption.'
    },
    {
      question: 'Is there a discount on TSS Subscription?',
      answer: 'Yes, we offer discounts on multi-year subscriptions. The 2-year subscription provides better value with an effective reduced yearly price.'
    }
  ];

  return (
    <div id="tss-page" className="tss-page p-0">
      {/* Hero Section */}
      <section className="tss-hero pt-5 section dark-background position-relative">
        <div style={heroBackgroundStyle}></div>
        <div className="container py-5">
          <div className="row py-5 align-items-center">
            <div className="col-lg-6">
              <h1 className="display-5 fw-bold mb-4">Powerful Upgrades and Connected Services for your Growing Business</h1>
              <p className="lead mb-4">
                Unlock advanced features with Tally Software Services (TSS). Get regular updates, remote access, 
                online data sync & more to power your TallyPrime.
              </p>
              <a href="#contact" className="btn btn-primary btn-lg">Get Started</a>
            </div>
            <div className="col-lg-6 text-center">
              <img 
                src="https://resources.tallysolutions.com/bd/en/wp-content/themes/tally/assets/images/tally-software-service/tss-banner.png" 
                alt="Tally Software Service" 
                className="img-fluid" 
                style={{ maxHeight: '400px' }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* What is TSS Section */}
      <section className="what-is-tss py-5 section light-background">
        <div className="container py-5">
          <SectionTitle 
            title="What is TSS?" 
            description1="Tally Software" 
            description2="Services" 
          />
          
          <div className="row mt-5">
            <div className="col-lg-8 mx-auto text-center">
              <p className="lead">
                Tally Software Services (TSS) is a software subscription for a collection of services 
                which add great value to your TallyPrime by giving you the latest developments in 
                technology and statutory laws.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Key Benefits */}
      <section className="key-benefits py-5 section bg-light">
        <div className="container py-5">
          <SectionTitle 
            title="Key Benefits" 
            description1="Enhanced" 
            description2="Productivity" 
          />
          
          <div className="row mt-5">
            {keyBenefits.map((benefit, index) => (
              <div className="col-md-6 col-lg-3 mb-4" key={index}>
                <div className="card h-100 p-4 border-0 custom-shadow-bottom">
                  <div className="mb-4 text-primary">
                    <i className="bi bi-star-fill fs-1"></i>
                  </div>
                  <h4 className="card-title h5">{benefit.title}</h4>
                  <p className="card-text">{benefit.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="testimonials py-5 section">
        <div className="container py-5">
          <SectionTitle 
            title="Testimonials" 
            description1="Customer" 
            description2="Success" 
          />
          
          <div className="row mt-5">
            {testimonials.map((item, index) => (
              <div className="col-md-6 mb-4" key={index}>
                <div className="card h-100 p-4 border-0 custom-shadow-bottom">
                  <div className="d-flex align-items-center mb-3">
                    <i className="bi bi-quote fs-1 text-primary me-3"></i>
                    <h5 className="mb-0">{item.company}</h5>
                  </div>
                  <p className="card-text">{item.quote}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Renew TSS Plans */}
      <section className="bg-light-cream">
        <div id="renew-tss" className="container py-5">
          <div className="row">
            <div className="col-lg-12">
              <div className="text-center mb-4">
                <h2>Renew your TSS</h2>
              </div>
            </div>
          </div>
          <div className="col-12 d-flex flex-column">
            <div className="col-12 card-navigator mb-5 clsYears">
              <div className="col-12 col-md-8 col-lg-5 p-2 d-flex bg-white m-auto rounded border">
                <ul className="col-12 p-0 nav nav-pills nav-fill validityTabContainer">
                  <li className="nav-item">
                    <p 
                      className={`nav-link durationTabTSS pointer mb-0 ${activeYear === 1 ? 'active' : ''}`} 
                      onClick={() => handleYearChange(1)} 
                      data-duration-id="1"
                    >
                      1 year
                    </p>
                  </li>
                  <li className="nav-item">
                    <p 
                      className={`nav-link durationTabTSS pointer mb-0 ${activeYear === 2 ? 'active' : ''}`} 
                      onClick={() => handleYearChange(2)} 
                      data-duration-id="2"
                    >
                      2 years
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            <div className="row flex-wrap justify-content-center">
              {/* Silver Plan */}
              <div className="col-md-6 col-xl-4 mb-4" id="TSS_1">
                <div className="card p-3 py-4 h-100 custom-shadow-bottom border rounded-3 cardContainer card-height">
                  <h4 className="text-theme mt-2">Silver</h4>
                  <p className="card-pid-text d-none itemId">29513</p>
                  <h3 className="price1" style={{ display: activeYear === 1 ? 'block' : 'none' }}><span>₹ </span>4,500</h3>
                  <h3 className="price price2" style={{ display: activeYear === 2 ? 'block' : 'none' }}><span>₹ </span>8,100</h3>
                  <input type="hidden" className="clsNumOfYears" value={activeYear} />
                  <p className="text-theme mb-3 clsEffPrice">
                    {activeYear === 1 ? 'Price for 1 year' : 'Effective price 4,050/Year'}
                  </p>
                  <p className="text-gray mb-3 gst1" style={{ display: activeYear === 1 ? 'block' : 'none' }}><span>₹ </span>18% GST (₹ 810)</p>
                  <p className="text-gray mb-3 gst gst2" style={{ display: activeYear === 2 ? 'block' : 'none' }}>+18% GST (₹ 1,458)</p>
                  <span className="off-tag position-absolute offerBadge" style={{ display: activeYear === 2 ? 'block' : 'none' }}>
                    <img src="https://resources.tallysolutions.com/wp-content/themes/tally/assets/images/tally-software-service/off-tag.svg" alt="" />
                  </span>
                  <div className="arrow-animation mt-auto">
                    <button className="btn btn-secondary w-100 mt-auto">Renew Now
                      <img className="arrow" src="https://resources.tallysolutions.com/wp-content/themes/tally/assets/images/arrow-up-right-sharp.svg" alt="arrow-up-right-blue" />
                    </button>
                  </div>
                  <h5 className="my-4">What you get:</h5>
                  <ul className="feature-list mb-3">
                    <li><img src="https://resources.tallysolutions.com/wp-content/themes/tally/assets/images/customer/black-tick.svg" alt="Check" /> Free upgrades to all major release</li>
                    <li><img src="https://resources.tallysolutions.com/wp-content/themes/tally/assets/images/customer/black-tick.svg" alt="Check" /> Connected Services for GST, Banking and WhatsApp Business</li>
                    <li><img src="https://resources.tallysolutions.com/wp-content/themes/tally/assets/images/customer/black-tick.svg" alt="Check" /> Anytime, Anywhere Access to reports and TallyPrime</li>
                    <li><img src="https://resources.tallysolutions.com/wp-content/themes/tally/assets/images/customer/black-tick.svg" alt="Check" /> Online Data Sync and consolidation</li>
                    <li className="emi-available"><img src="https://resources.tallysolutions.com/wp-content/themes/tally/assets/images/customer/blue-tick.svg" alt="Check" /> EMI Available</li>
                  </ul>
                  <p className="text-theme clsTssDiscText">Applicable only for TallyPrime users</p>
                </div>
              </div>

              {/* Gold Plan */}
              <div className="col-md-6 col-xl-4 mb-4" id="TSS_2">
                <div className="card p-3 py-4 position-relative h-100 custom-shadow-bottom border rounded-3 cardContainer card-height">
                  <h4 className="text-theme mt-2">Gold</h4>
                  <p className="card-pid-text d-none itemId">29514</p>
                  <h3 className="price1" style={{ display: activeYear === 1 ? 'block' : 'none' }}><span>₹ </span>13,500</h3>
                  <h3 className="price price2" style={{ display: activeYear === 2 ? 'block' : 'none' }}><span>₹ </span>24,300</h3>
                  <input type="hidden" className="clsNumOfYears" value={activeYear} />
                  <p className="text-theme mb-3 clsEffPrice">
                    {activeYear === 1 ? 'Price for 1 year' : 'Effective price 12,150/Year'}
                  </p>
                  <p className="text-gray mb-3 gst1" style={{ display: activeYear === 1 ? 'block' : 'none' }}><span>₹ </span>18% GST (₹ 2,430)</p>
                  <p className="text-gray mb-3 gst gst2" style={{ display: activeYear === 2 ? 'block' : 'none' }}>+18% GST (₹ 4,374)</p>
                  <span className="off-tag position-absolute offerBadge" style={{ display: activeYear === 2 ? 'block' : 'none' }}>
                    <img src="https://resources.tallysolutions.com/wp-content/themes/tally/assets/images/tally-software-service/off-tag.svg" alt="" />
                  </span>
                  <div className="arrow-animation mt-auto">
                    <button className="btn btn-secondary w-100">Renew Now
                      <img className="arrow" src="https://resources.tallysolutions.com/wp-content/themes/tally/assets/images/arrow-up-right-sharp.svg" alt="arrow-up-right-blue" />
                    </button>
                  </div>
                  <h5 className="my-4">What you get:</h5>
                  <ul className="feature-list mb-3">
                    <li><img src="https://resources.tallysolutions.com/wp-content/themes/tally/assets/images/customer/black-tick.svg" alt="Check" /> Free upgrades to all major release</li>
                    <li><img src="https://resources.tallysolutions.com/wp-content/themes/tally/assets/images/customer/black-tick.svg" alt="Check" /> Connected Services for GST, Banking and WhatsApp Business</li>
                    <li><img src="https://resources.tallysolutions.com/wp-content/themes/tally/assets/images/customer/black-tick.svg" alt="Check" /> Anytime, Anywhere Access to reports and TallyPrime</li>
                    <li><img src="https://resources.tallysolutions.com/wp-content/themes/tally/assets/images/customer/black-tick.svg" alt="Check" /> Online Data Sync and consolidation</li>
                    <li className="emi-available"><img src="https://resources.tallysolutions.com/wp-content/themes/tally/assets/images/customer/blue-tick.svg" alt="Check" /> EMI Available</li>
                  </ul>
                  <p className="text-theme clsTssDiscText">Applicable only for TallyPrime users</p>
                </div>
              </div>

              {/* Auditor Plan */}
              <div className="col-md-6 col-xl-4 mb-4" id="TSS_10">
                <div className="card p-3 py-4 position-relative h-100 custom-shadow-bottom border rounded-3 cardContainer">
                  <h4 className="text-theme mt-2">Auditor</h4>
                  <p className="card-pid-text d-none itemId">29515</p>
                  <h3 className="price1" style={{ display: activeYear === 1 ? 'block' : 'none' }}><span>₹ </span>6,750</h3>
                  <h3 className="price price2" style={{ display: activeYear === 2 ? 'block' : 'none' }}><span>₹ </span>12,150</h3>
                  <input type="hidden" className="clsNumOfYears" value={activeYear} />
                  <p className="text-theme mb-3 clsEffPrice">
                    {activeYear === 1 ? 'Price for 1 year' : 'Effective price 6,075/Year'}
                  </p>
                  <p className="text-gray mb-3 gst1" style={{ display: activeYear === 1 ? 'block' : 'none' }}><span>₹ </span>18% GST (₹ 1,215)</p>
                  <p className="text-gray mb-3 gst gst2" style={{ display: activeYear === 2 ? 'block' : 'none' }}>+18% GST (₹ 2,187)</p>
                  <span className="off-tag position-absolute offerBadge" style={{ display: activeYear === 2 ? 'block' : 'none' }}>
                    <img src="https://resources.tallysolutions.com/wp-content/themes/tally/assets/images/tally-software-service/off-tag.svg" alt="" />
                  </span>
                  <div className="arrow-animation">
                    <button className="btn btn-secondary w-100">Renew Now
                      <img className="arrow" src="https://resources.tallysolutions.com/wp-content/themes/tally/assets/images/arrow-up-right-sharp.svg" alt="arrow-up-right-blue" />
                    </button>
                  </div>
                  <h5 className="my-4">What you get:</h5>
                  <ul className="feature-list mb-3">
                    <li><img src="https://resources.tallysolutions.com/wp-content/themes/tally/assets/images/customer/black-tick.svg" alt="Check" /> Free upgrades to all major release</li>
                    <li><img src="https://resources.tallysolutions.com/wp-content/themes/tally/assets/images/customer/black-tick.svg" alt="Check" /> Connected Services for GST, Banking and WhatsApp Business</li>
                    <li><img src="https://resources.tallysolutions.com/wp-content/themes/tally/assets/images/customer/black-tick.svg" alt="Check" /> Anytime, Anywhere Access to reports and TallyPrime</li>
                    <li><img src="https://resources.tallysolutions.com/wp-content/themes/tally/assets/images/customer/black-tick.svg" alt="Check" /> Online Data Sync and consolidation</li>
                    <li className="emi-available"><img src="https://resources.tallysolutions.com/wp-content/themes/tally/assets/images/customer/blue-tick.svg" alt="Check" /> EMI Available</li>
                  </ul>
                  <p className="text-theme clsTssDiscText">Applicable only for TallyPrime users</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq py-5 section">
        <div className="container py-5">
          <SectionTitle 
            title="Frequently Asked Questions" 
            description1="Common" 
            description2="Questions" 
          />
          
          <div className="row mt-5">
            <div className="col-lg-8 mx-auto">
              <div className="accordion" id="tssFaqAccordion">
                {faqs.map((faq, index) => (
                  <div className="accordion-item mb-3 border rounded-3 overflow-hidden" key={index}>
                    <h2 className="accordion-header" id={`heading${index}`}>
                      <button 
                        className={`accordion-button ${index !== 0 ? 'collapsed' : ''}`} 
                        type="button" 
                        data-bs-toggle="collapse" 
                        data-bs-target={`#collapse${index}`} 
                        aria-expanded={index === 0 ? 'true' : 'false'} 
                        aria-controls={`collapse${index}`}
                      >
                        {faq.question}
                      </button>
                    </h2>
                    <div 
                      id={`collapse${index}`} 
                      className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`} 
                      aria-labelledby={`heading${index}`} 
                      data-bs-parent="#tssFaqAccordion"
                    >
                      <div className="accordion-body">
                        {faq.answer}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta py-5 section bg-primary text-white">
        <div className="container py-5 text-center">
          <h2 className="text-white">Ready to enhance your TallyPrime experience?</h2>
          <p className="lead mb-4">Get TSS today and unlock powerful features for your growing business.</p>
          <a href="#contact" className="btn btn-light btn-lg">Contact Us</a>
        </div>
      </section>
    </div>
  );
};

export default TSS;  